import Swiper from "swiper/bundle"

let mySwiper = null

export const swiperInit = () => {

    let swiperSetting = {
        autoplay: {
            delay: 6500,
        },
        speed: 1000,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    }
    if (!document.body.classList.contains("single-works"))
        if (mySwiper == null) {
            mySwiper = new Swiper(".mySwiper", swiperSetting);
        } else {
            mySwiper.update()
            mySwiper.autoplay.start()
        }

    let homeSwiper = new Swiper(".homeSwiper", swiperSetting);
    let spHomeSwiper = new Swiper(".spHomeSwiper", swiperSetting);

    let worksSwiper = new Swiper(".worksSwiper", swiperSetting);
}


{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */

    // @import '../../node_modules/swiper/swiper-bundle.min.css';

}